import type { InputFrame, MatchConfig, RollbackGame } from '@hf/shared';
import { INPUT_NONE, PLAYER_COUNT } from '@hf/shared';
import { cloneInto, cloneState } from './clone';
import type { SimEvent } from './events';
import { hashState } from './hash';
import { createInitialState, type SimState } from './state';
import { step } from './step';

/** The sim as a RollbackGame for @hf/netcode (and the client's local driver). */
export const simGame: RollbackGame<SimState, InputFrame, SimEvent, MatchConfig> = {
  playerCount: PLAYER_COUNT,
  neutralInput: INPUT_NONE,
  createState: createInitialState,
  step,
  cloneInto,
  clone: cloneState,
  hash: hashState,
  tickOf: (s) => s.tick,
};
